<template>
	<div>
		<p>
			Die nachfolgenden Allgemeinen Geschäftsbedingungen der Jugendreferate
			Allgäu-Oberschwaben (haftungsbeschränkt), Eisenbahnstraße 25, 88212
			Ravensburg, (nachfolgend auch Anbieter:in und oder Veranstalter:in) regeln
			sowohl den Erwerb von Tickets für das Propellerfestival 2025 (Teil A) als
			auch die Bedingungen, die für diese Veranstaltung (haftungsbeschränkt)
			(Teil B). Mit dem Erwerb und Besitz eines Tickets zu dieser Veranstaltung
			akzeptiert der/die Teilnehmer:in -nachfolgend auch Käufer:in und oder
			Besucher:in genannt- die Anwendbarkeit dieser Allgemeinen
			Geschäftsbedingungen- im Folgenden „AGB“ genannt. Zudem muss die
			Datenschutzerklärung beachtet werden.
		</p>
		<p>
			Im Folgenden wird zur Bezeichnung von Kunden, Besuchern, Teilnehmern,
			Veranstaltern und anderen Personen aus Gründen der besseren Lesbarkeit
			grundsätzlich die weibliche Form („Käuferin“, „Besucherin“,
			„Veranstalterin“, „Teilnehmerin“ etc.) verwendet. Diese Bezeichnungen
			sowie ggf. in der männlichen Form gehaltene Personenbezeichnungen beziehen
			sich jeweils auf Personen allen Geschlechts.
		</p>
		<h2>TEIL A Tickets</h2>
		<h3>1 Geltungsbereich</h3>
		<p>
			Die Geschäftsbedingungen gelten für alle Verträge, die mit der Anbieterin
			(Katholische Jugendreferate Allgäu-Oberschwaben) über die Internetseite
			www.propellerfestival.de geschlossen werden. Soweit nicht anders
			vereinbart, wird der Einbeziehung gegebenenfalls verwendeter eigener
			Bedingungen widersprochen.
		</p>
		<h3>2 Vertragsparteien, Einbeziehung von AGB der Veranstalterin</h3>
		<p>
			a. Durch den Kauf eines Tickets oder der Registrierung für eine
			Veranstaltung auf den Websites der Anbieterin, entsteht zwischen der
			jeweiligen Teilnehmerin und der jeweiligen Veranstalterin ein Kaufvertrag
			hinsichtlich des Besuchs der Veranstaltung. Auftrag und Abwicklung des
			Ticketverkaufs erfolgt über die Anbieterin.
		</p>
		<p>
			b. Für die Durchführung der von der Anbieterin angebotenen Veranstaltung
			gelten möglicherweise zusätzliche AGB der jeweiligen Veranstalterin. Die
			Teilnehmerin ist selbst dafür verantwortlich, dass sie sich vor dem Kauf
			des Tickets über eventuell existierende AGB der Veranstalterin informiert.
		</p>
		<p>
			c. Die Teilnehmerin sichert zu, dass sie zum Zeitpunkt der Registrierung
			das 16. Lebensjahr vollendet hat.
		</p>
		<h3>3 Vertragsgegenstand und Vertragsschluss</h3>
		<p>
			a. Die Informationen über die jeweilige Veranstaltung, die Anzahl der
			verfügbaren Tickets, der Ticketpreis, sowie die verfügbaren
			Zahlungsmethoden richten sich ausschließlich nach den Einstellungen, die
			die Katholischen Jugendreferate Allgäu-Oberschwaben (haftungsbeschränkt)
			bei der Erstellung des Angebots für die Veranstaltung auf der
			Anbieter-Website gemacht hat.
		</p>
		<p>
			b. Die Veranstalterin gibt mit den in Ziffer a. gemachten Angaben ein
			Angebot für den Abschluss eines Kaufvertrages ab. Die Teilnehmerin nimmt
			ihr Angebot für den Abschluss eines Kaufvertrages an, indem sie in der
			jeweiligen Bestellmaske auf den Button „Anmelden“ klickt. Die wirksame
			Annahme des Angebots durch die Teilnehmerin setzt voraus, dass die
			Teilnehmerin in der Bestellmaske alle erforderlichen Felder ausgefüllt
			(jeweils durch „*“ gekennzeichnet) und diese AGB, sowie die
			Datenschutzerklärung akzeptiert hat.
		</p>
		<p>
			Unverzüglich nach Vertragsschluss erhält die Teilnehmerin eine
			Bestätigungs-E-Mail über den Abschluss des Kaufvertrages. Die Teilnehmerin
			ist verpflichtet, uns zu unterrichten, wenn sie diese Bestätigungs-E-Mail
			nicht oder nicht rechtzeitig erhalten hat.
		</p>
		<p>
			c. Die Anbieterin und Veranstalterin sind berechtigt, eine Bestellung der
			Teilnehmerin zu stornieren (einseitiges Rücktrittsrecht), wenn die
			Teilnehmerin gegen von der Veranstalterin bzw. der Anbieterin aufgestellte
			spezifische Bedingungen, auf die im Rahmen des Vorverkaufs hingewiesen
			wurde, verstößt oder diese zu umgehen versucht. Die Erklärung der
			Stornierung/des Rücktritts kann auch durch Gutschrift der gezahlten
			Beträge erfolgen. § 350 BGB findet keine Anwendung.
		</p>
		<p>
			d. Sollten Teilnehmerinnen besondere Anforderungen an die Barrierefreiheit
			einer Veranstaltung haben, so müssen sie sich vor dem Erwerb von Tickets
			an die Katholischen Jugendreferate Allgäu-Oberschwaben
			(haftungsbeschränkt) wenden, damit diese sie unterstützen kann. Ansonsten
			können konkrete Anforderungen für die Veranstaltung ggf. nicht
			gewährleistet werden.
		</p>
		<h3>4 Widerrufsrecht für Verbraucherinnen</h3>
		<p>
			a. Generelle Bestätigung. Die Teilnehmerin ist ausdrücklich damit
			einverstanden, dass die Veranstalterin vor dem Ende der Widerrufsfrist mit
			der Ausführung der Dienstleistung, die Gegenstand des zu schließenden
			Vertrags ist, beginnen soll. Ferner ist der Teilnehmerin bekannt, dass
			bereits mit vollständiger Vertragserfüllung durch die Anbieterin und
			Veranstalterin das gesetzlich zustehende Widerrufsrecht verloren wird.
		</p>
		<p>
			b. Widerrufsrecht bezüglich Eintrittskarten für Veranstaltungen: Das neu
			verabschiedete Fernabsatzgesetz sieht ein generelles Widerrufs- oder
			Rückgaberecht der Käuferin vor, bei dem sich Anbieterin und Käuferin nicht
			persönlich gegenüberstehen. Ausnahmen vom neuen Fernabsatzgesetz sind u.a.
			bei Reservierungsdienstleistungen wie z.B. Eintrittskartenverkauf
			vorgesehen. Dazu ein Auszug aus dem Fernabsatzgesetz: "Dieses Gesetz
			findet keine Anwendung auf Verträge ... ... über die Erbringung von
			Dienstleistungen in den Bereichen Unterbringung, Beförderung, Lieferung
			von Speisen und Getränken sowie Freizeitgestaltung, wenn sich der
			Unternehmer bei Vertragsabschluss verpflichtet, die Dienstleistungen zu
			einem bestimmten Zeitpunkt oder innerhalb eines genau angegebenen
			Zeitraums zu erbringen."
		</p>
		<p>c. Die Bestellung von Tickets ist eine verbindliche Bestellung.</p>
		<p>
			d. Jede Bestellung von Tickets ist unmittelbar nach Bestätigung durch die
			Anbieterin bindend und verpflichtet zur Abnahme und Bezahlung der
			bestellten Karten bzw. Tickets. Sollte der Teilnahmebeitrag durch
			Fernbleiben der Veranstaltung nicht geleistet werden, wird eine
			entsprechende Rechnung durch die Anbieterin gestellt.
		</p>
		<h3>
			5 Zahlungswege und Zahlungsbedingungen, nicht eingelöste Zahlungen,
			Gebühren
		</h3>
		<p>
			a. Der Teilnahmebeitrag in Höhe von
			<b>25€</b>
			ist am Tag der Veranstaltung in bar zu bezahlen, wenn nicht vorher ein
			Ticket online gekauft wurde. Ein vorher gekauftes Ticket wird beim Einlass
			überprüft und entwertet. Ein Early-Bird-Ticket ist nur bis zum 30.04.2025
			zu erhalten und kostet
			<b>20€</b>
			.
		</p>
		<p>
			b. Die Anbieterin bzw. die Veranstalterin ist berechtigt, Rechnungen in
			elektronischer Form zu stellen, insbesondere per E-Mail.
		</p>
		<h3>6 Rückgabe von Tickets, Erstattung des Kaufpreises</h3>
		<p>
			a. Wird eine Veranstaltung abgesagt oder verschoben, so bestimmt sich das
			Recht der Teilnehmerin ein schon gekauftes Ticket zurückzugeben nach den
			gesetzlichen Bestimmungen sowie den Vereinbarungen, die die Teilnehmerin
			mit der Veranstalterin getroffen hat (Teil B dieser AGB).
		</p>
		<h3>7 Haftung und Gewährleistung</h3>
		<p>
			a. Die Anbieterin haftet ferner unbeschränkt für Schäden, die von ihm oder
			einem gesetzlichen Vertreter oder Erfüllungsgehilfen vorsätzlich oder
			durch grobe Fahrlässigkeit verursacht wurden.
		</p>
		<p>
			b. Bei leicht fahrlässig verursachten Verletzung wesentlicher
			Vertragspflichten haftet die Anbieterin, außer in den Fällen von Ziffer 10
			c., der Höhe nach begrenzt auf den vertragstypisch vorhersehbaren Schaden.
			Wesentliche Vertragspflichten sind solche Pflichten, deren Erfüllung die
			ordnungsgemäße Durchführung eines Vertrages überhaupt erst ermöglicht und
			auf deren Einhaltung die Vertragsparteien regelmäßig vertrauen dürfen.
		</p>
		<p>c. Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.</p>
		<p>
			d. Jede weitere Haftung auf Schadensersatz ist ausgeschlossen,
			insbesondere eine verschuldensunabhängige Haftung. Wir und unsere
			Erfüllungsgehilfen haften auch nicht für Störungen gleich welcher Art, die
			durch Umstände außerhalb ihres Einflussbereiches hervorgerufen werden.
			Insbesondere gilt dies für einen Ausfall oder eine Störung der
			Telekommunikationsleitung oder Stromversorgung.
		</p>
		<p>
			e. Die Verjährungsfrist für Schadenersatzansprüche gegen die Anbieterin
			beträgt ein Jahr, außer in den Fällen der Ziffern 10 a. und 10 c. und /
			oder die Teilnehmerin ist ein Verbraucher im Sinne von § 13 BGB.
		</p>
		<h2>TEIL B Veranstaltungen</h2>
		<h3>1 Geltungsbereich der Allgemeinen Geschäftsbedingungen</h3>
		<p>
			a. Die allgemeinen Geschäftsbedingungen (im Folgenden „AGB“ genannt)
			gelten für den Besuch von Veranstaltungen von uns, den Katholischen
			Jugendreferaten Allgäu-Oberschwaben (haftungsbeschränkt) Eisenbahnstraße
			25, 88212 Ravensburg, Deutschland – im Folgenden auch Veranstalterin
			genannt -, sowie für das Betreten der von uns genutzten
			Veranstaltungsfläche inklusive Parkplätze, Campingplätzen und Wege zur
			Veranstaltungsstätte.
		</p>
		<p>
			b. Mit dem Erwerb der Eintrittskarte (auch beim Kaufvertrag mit einem
			Drittanbieter) erkennst du – im Folgenden auch „Besucherin“ genannt- die
			Gültigkeit dieser AGB an. Dies gilt auch, wenn die Veranstaltungsstätte in
			sonstigen Fällen betreten wird.
		</p>
		<p>
			c. Diese AGB gelten gleichzeitig als Hausordnung für das Propeller
			Festival.
		</p>
		<h3>2 Hausrecht</h3>
		<p>a. Das Hausrecht obliegt der Veranstalterin.</p>
		<p>
			b. Der der Veranstalterin eingesetzte Sicherheits- und Ordnungsdienst ist
			berechtigt, im Namen der Veranstalterin das Hausrecht auszuüben und
			durchzusetzen, insbesondere Kontrollen nach dieser Hausordnung
			durchzuführen oder den Verweis und die Verbringung vom
			Veranstaltungsgelände gemäß dieser Hausordnung oder den gesetzlichen
			Vorschriften durchzusetzen.
		</p>
		<h3>3 Erwerb von Tickets</h3>
		<p>a. Es gelten die Bestimmungen aus Teil A.</p>
		<p>
			b. Tickets dürfen nur erworben werden, wenn die Käuferin beabsichtigt,
			selbst mit diesen Karten die Veranstaltung zu besuchen oder sie in seinem
			Freundes- oder Verwandtenkreis oder sie in üblichem Rahmen an
			Geschäftspartner oder sonst nahestehende Kreise zu verschenken oder
			weiterzugeben.
		</p>
		<p>
			c. Der Erwerb der Tickets zum Zwecke des Weiterverkaufs an unbekannte
			Dritte ist verboten.
		</p>
		<p>
			d. Das Herstellen und Inverkehrbringen von gefälschten Tickets wird
			strafrechtlich verfolgt.
		</p>
		<p>
			e. Mit dem Kauf von Tickets akzeptierst du eine mögliche, Covid-19
			bedingte, Verschiebung oder Absage des Festivals auf einen Termin, zu dem
			die Durchführung der Veranstaltung wieder möglich sein wird.
		</p>
		<h3>4 Absage, Verschiebung oder Abbruch der Veranstaltung</h3>
		<p>
			a. Veranstaltungen können abgesagt oder verschoben werden. Sollte dieser
			Fall eintreten, werden wir dies über unsere Homepage
			https://www.propellerfestival.de, sowie unseren Social-Media-Kanälen
			bekannt geben. Bitte informiere dich also über diese Medien, ob die
			Veranstaltung wie geplant stattfinden wird.
		</p>
		<p>
			b. Sollte es zu einer Absage, einem Abbruch, einer Verschiebung oder einer
			wesentlichen Änderung der Veranstaltung kommen so beschränkt sich unsere
			Haftung auf den reinen Nennwert der gekauften Tickets.
			Darüberhinausgehende Kosten erfolgen auf eigene Gefahr und sind von der
			Haftung ausgeschlossen.
		</p>
		<p>
			c. Eine wesentliche Veränderung der Veranstaltung liegt vor, wenn ein
			Ereignis eintritt, welches den Charakter der Veranstaltung wesentlich
			gegenüber dem verändert, was du beim Ticketkauf erwarten durftest.
		</p>
		<p>
			d. Änderungen eines oder mehrerer Künstlerinnen im Programm des Propeller
			Festivals stellen keine solche wesentliche Änderung dar.
		</p>
		<h3>5 Einlass der Besucherinnen</h3>
		<p>
			a. Der Einlass zu, Propeller Festival ist grundsätzlich ab 16 Jahren (mit
			Begleitung einer erziehungsberechtigten / erziehungsbeauftragten Person).
			Bei Einlass von Besucherinnen unter 18 Jahren gilt das Jugendschutzgesetz,
			sowie die Regelungen auf unserer Homepage
			<a href="www.propellerfestival.de">www.propellerfestival.de</a>
			. Wir sind zudem berechtigt, zur Überprüfung des Alters geeignete
			Legitimationspapiere (z.B. Personalausweis) zu fordern.
		</p>
		<p>
			b. Einlass wird nur gegen Vorlage eines gültigen Tickets gewährt und nur
			dann, wenn die Besucherin die Bedingungen dieser Hausordnung erfüllt.
		</p>
		<p>
			c. Zur Gültigkeit der Eintrittskarte siehe "3 Erwerb von Eintrittskarten"
		</p>
		<p>
			d. Die Veranstalterin ist berechtigt, im Einzelfall das Vorzeigen eines
			amtlichen Lichtbildausweises zu verlangen.
		</p>
		<p>e. Mit dem Einlass werden die Eintrittskarten entwertet.</p>
		<p>
			f. Die Besucherin willigt in Kontrollmaßnahmen seiner Bekleidung und
			mitgebrachten Taschen und Behältnisse aus Sicherheitsgründen und zur
			Kontrolle der Einhaltung dieser Hausordnung am Einlass ein.
		</p>
		<p>
			g. Einlasszeiten können von der Veranstalterin verändert werden,
			insbesondere wenn dies aus Sicherheitsgründen geboten ist.
		</p>
		<p>h. Der Einlass gegenüber der Teilnehmerin kann verwehrt werden, wenn</p>
		<ul class="standard-list">
			<li>die Besucherin keine gültige Eintrittskarte besitzt,</li>
			<li>
				die Besucherin die Vorlage von Legitimationspapieren im Falle einer
				Altersüberprüfung verweigert,
			</li>
			<li>
				die Besucherin eine Kontrollmaßnahme ihrer Bekleidung, Utensilien oder
				Behältnisse verweigert,
			</li>
			<li>
				die Besucherin erkennbar unter dem Einfluss von Alkohol, Drogen oder
				sonst berauschenden Mitteln steht,
			</li>
			<li>
				die Besucherin Waffen oder gesetzlich verbotene Gegenstände (siehe „7
				Aufenthalt auf dem Veranstaltungsgelände“) bei sich führt,
			</li>
			<li>gegen die Besucherin ein Hausverbot besteht,</li>
			<li>
				die Besucherin erkennbar beabsichtigt, den Veranstaltungsablauf zu
				stören, Gewalt auszuüben oder dazu anzustiften,
			</li>
			<li>
				die Besucherin im Vorfeld durch Kundgabe von rassistischen,
				menschenverachtenden, fremdenfeindlichen oder sexuellen Äußerungen in
				Wort, Bild oder Verhalten auffällt oder eine solche Kundgabe erkennbar
				beabsichtigt ist, oder
			</li>
			<li>
				im Übrigen die Besucherin erkennbar beabsichtigt, gegen die Hausordnung
				zu verstoßen.
			</li>
		</ul>
		<p>
			In diesem Fall hat die Besucherin keinen Anspruch auf Erstattung des
			Eintrittspreises. Das Recht der Veranstalterin, Schadenersatz geltend zu
			machen, bleibt unberührt.
		</p>
		<h3>6 Barrierefreiheit</h3>
		<p>
			a. Sollten Besucherinnen besondere Anforderungen an die Barrierefreiheit
			einer Veranstaltung haben, wenden sie sich bitte vor dem Erwerb von
			Tickets an die Veranstalterin, damit diese sie unterstützen kann.
			Ansonsten können konkrete Anforderungen für die Veranstaltung ggf. nicht
			gewährleistet werden.
		</p>
		<h3>7 Aufenthalt auf dem Veranstaltungsgelände</h3>
		<p>
			a. Bei Verlust von Wertmarken, Pfandmarken, des Eintrittsbandes oder
			Müllpfandbändchen werden diese nicht ersetzt.
		</p>
		<p>
			b. Die Besucherin hat sich so zu verhalten, dass die Veranstalterin,
			andere Besucherinnen und Dritte nicht geschädigt, gefährdet oder belästigt
			werden.
		</p>
		<p>
			c. Den Anweisungen der Veranstalterin und des Sicherheits- und
			Ordnungsdienstes ist unbedingt Folge zu leisten.
		</p>
		<p>
			d. Brandschutzeinrichtungen und Sicherheitseinrichtungen dürfen nicht,
			auch nicht nur vorübergehend, verstellt, versperrt, verhangen oder sonst
			beeinträchtigt oder missbraucht werden.
		</p>
		<p>e. Es ist den Besucherinnen verboten,</p>
		<ul class="standard-list">
			<li>den Veranstaltungsablauf zu stören,</li>
			<li>
				in Gebäuden außerhalb der gekennzeichneten Raucherbereiche zu rauchen,
			</li>
			<li>
				strafbare, ordnungswidrige oder allgemein zu missbilligende Handlungen
				vorzunehmen oder dabei behilflich zu sein oder dazu anzustiften,
			</li>
			<li>andere Besucherinnen zu gefährden,</li>
			<li>
				Feuer zu machen, Feuerwerkskörper oder pyrotechnische Gegenstände zu
				zünden,
			</li>
			<li>
				Anlagen und Einrichtungen, usw. zu beschmieren, zu beschädigen oder zu
				entfernen,
			</li>
			<li>
				Zäune, Lichtmasten, Gebäude, Stromkästen, Sanitärstationen,
				Mobiltoiletten und andere Infrastruktureinrichtungen auf dem
				Veranstaltungsgelände zu besteigen,
			</li>
			<li>
				Absperrungen zu umgehen, oder erkennbar nicht den Besucherinnen
				zugängliche Bereiche zu betreten oder dabei behilflich zu sein,
			</li>
			<li>das Veranstaltungsgelände zu verunreinigen,</li>
			<li>
				Werbung jeglicher Art zu betreiben oder Flugblätter oder sonstige
				Materialien zu verteilen, sofern dies vom Veranstalter zuvor nicht
				ausdrücklich und schriftlich erlaubt wurde,
			</li>
			<li>
				menschenverachtende, rassistische, fremdenfeindliche,
				politisch-extremistische, obszön anstößige oder beleidigende, links-
				oder rechtsradikale oder sonstige radikale Parolen zu äußern oder zu
				verbreiten,
			</li>
			<li>
				links- oder rechts- oder anders extremistisch zu handeln, insbesondere
				Zeigen und Verwenden nationalsozialistischer Parolen (§ 86a StGB),
			</li>
			<li>
				ungenehmigt Getränke, Lebensmittel, Souvenirs, Kleider, Werbeartikel,
				Fan-Artikel, Merchandise-Artikel und/oder andere Waren und Gegenstände
				zu verteilen oder zu verkaufen.
			</li>
			<li>
				Ton-, Foto-, Film- und Videoaufnahmen der Veranstaltung oder Teilen
				davon für den gewerblichen und/oder kommerziellen Gebrauch zu erstellen,
			</li>
			<li>
				Ton-, Foto-, Film- und Videoaufnahmen der Künstlerinnen und ihrer
				Darbietungen auch für den privaten Gebrauch zu erstellen (dies ist auch
				schon durch das Urheberrechtsgesetz verboten),
			</li>
			<li>außerhalb der Toilettenräume seine Notdurft zu verrichten.</li>
		</ul>
		<p>
			f. Im Übrigen gelten die Bestimmungen für die Nutzung des Camping und dem
			Parken (Punkt 13).
		</p>
		<p>
			g. Bei einem Verstoß kann die Veranstalterin einen Veranstaltungsverweis
			gegenüber der Besucherin aussprechen. In diesem Fall hat die Besucherin
			keinen Anspruch auf erneuten Einlass oder Erstattung des Eintrittspreises.
			Das Recht der Veranstalterin, Schadenersatz geltend zu machen, bleibt
			unberührt.
		</p>
		<h3>8 Verbotene Gegenstände</h3>
		<p>
			a. Die Veranstalterin behält sich vor, aus Sicherheitsgründen einzelne
			Gegenstände vor Ort auszuschließen. Dem Ordnungs- und Sicherheitspersonal
			der Veranstalterin ist Folge zu leisten.
		</p>
		<p>
			b. Das Mitbringen von gefährlichen Gegenständen ist verboten. Hierzu
			zählen insbesondere Glasbehälter, Dosen, Tonbandgeräte, Film-, Foto- und
			Videokameras, sperrige Gegenstände, Kühltaschen, Plastikkanister,
			pyrotechnischen Gegenstände, Fackeln, Wunderkerzen, Waffen, Laserpointer
			und sonstige in ihrer Art anlässlich eines Veranstaltungsbesuchs
			gefährliche Gegenstände.
		</p>
		<p>
			c. Das Mitbringen von Tieren ist untersagt. Bei Nichtbeachtung und
			Nichteinhaltung dieses Verbotes erfolgt der Verweis vom Veranstaltungsort.
		</p>
		<p>
			d. Auf dem Propellerfestival wird es günstiges Essen und Trinken geben,
			daher bitten wir euch, auf Gaskocher, Grills, etc. zu verzichten.
			Glasflaschen sind auf dem Zeltplatz verboten, da die Wiese im Anschluss
			als Futterwiese genutzt wird.
		</p>
		<p>
			e. Alkohol: Wir haben ein breites Getränkeangebot für euch vorbereitet und
			dies zu einem günstigen Preis, daher werden wir weder Fremdalkohol noch
			Hartalk. auf dem Festival zulassen.
		</p>
		<p>
			Die Auflistung erhebt keinen Anspruch auf Vollständigkeit. Im Zweifel gilt
			immer die Aussage des Sicherheitspersonals und der Crew.
		</p>
		<h3>9 Sicherheit</h3>
		<p>
			a. Den Besucherinnen wird empfohlen, sich im Vorfeld bzw. bei Eintritt in
			das Veranstaltungsgelände mit den vorhandenen und gekennzeichneten
			Rettungswegen vertraut zu machen.
		</p>
		<p>
			b. Den Anweisungen der Veranstalterin und des Sicherheits- und
			Ordnungsdienstes oder der Polizei ist unbedingt Folge zu leisten.
		</p>
		<p>
			c. Es handelt sich um eine Musikveranstaltung. Musik ist geeignet,
			aufgrund der Lautstärke Gesundheitsschäden und Hörschäden hervorzurufen.
			Der Besucher wird darauf hingewiesen, dass ein längerer Aufenthalt in
			unmittelbarer Nähe zur Musikanlage gesundheitsschädlich ist.
		</p>
		<p>
			e. Die Veranstaltung findet grundsätzlich bei jeder Witterung statt. Wir
			behalten uns jedoch vor, bei einer witterungsbedingten Gefährdung der
			Besucherinnen die Veranstaltung zu unterbrechen oder abzusagen.
		</p>
		<p>
			f. Aus Sicherheitsgründen können wir als Veranstalterin einzelne Bereiche
			des Festivalgeländes vorübergehend oder vollständig räumen und absperren,
			ohne dass dies einen Anspruch auf teilweise Rückerstattung des
			Kartenpreises begründet, soweit die Besucherinnen dadurch nicht
			wesentliche Teile der Veranstaltung selbst nicht mehr erleben kann. Den
			diesbezüglichen Anweisungen des Veranstalters oder den Anweisungen der von
			ihm beauftragten Personen und Firmen ist unmittelbar Folge zu leisten, um
			Gefahr für Leib oder Leben abzuwenden.
		</p>
		<h3>11 Aufzeichnungen des Veranstalters</h3>
		<p>
			Die Veranstalterin und durch sie beauftragte Dritte, Sponsoren und Partner
			sind berechtigt, im Rahmen der Veranstaltungen Bild-, Ton- und
			Bildtonaufnahmen der Besucherinnen ohne Vergütung für die abgebildeten
			Personen herzustellen und in jeder Art und Weise umfassend in allen
			bekannten und zukünftigen Medien zu nutzen oder nutzen zu lassen,
			insbesondere zur Berichterstattung in allen Medien eingeschlossen
			Internet, auf Ton- oder Bildtonträgern sowie zur Bewerbung des Festivals,
			zur Sponsorenakquise und zu allen sonstigen Geschäftstätigkeiten der
			Veranstalterin und ihrer verbundenen Unternehmen. Sämtliche Rechte dürfen
			auch zu vorstehenden Zwecken auf Dritte übertragen werden. Die Besucherin
			ist hiermit einverstanden.
		</p>
		<h3>12 Programm</h3>
		<p>
			a. Die Veranstalterin behält sich vor, Teile des Programms ändern,
			insbesondere wenn dies bei einer Absage oder einem Ausfall von
			Künstlerinnen oder aufgrund der Wetterlage oder anderer Einflüsse auf die
			Veranstaltung notwendig ist.
		</p>
		<p>
			b. Die Künstlerinnen sind für die Inhalte ihrer Darbietung allein
			verantwortlich, wir als Veranstalterin nehmen lediglich durch die Auswahl
			der Künstlerinnen Einfluss auf das Programm.
		</p>
		<p>
			c. Die Teilnahme an sämtlichen Workshops und anderen Angeboten erfolgt auf
			eigene Gefahr. Die Veranstalterin übernimmt hierbei keinerlei Haftung.
		</p>
		<h3>13 Camping Propellerfestival</h3>
		<p>
			a. Es darf nur in Zelten in unserem Camp übernachtet werden. Für
			Busle/WoMo´s etc. gibt es keine Übernachtungsmöglichkeit.
		</p>
		<p>
			b. Campen außerhalb des offiziellen Campingplatzes ist ausdrücklich
			untersagt.
		</p>
		<p>
			c. Autos dürfen generell nicht auf den Campingplatz und müssen außerhalb
			auf dem Parkplatz abgestellt werden.
		</p>
		<p>
			d. Auch auf dem Campingplatz gilt der Jugendschutz, Altersbeschränkungen
			wie in Punkt 5 a. sind hier ebenso zu beachten.
		</p>
		<p>
			e. Das Camp befindet sich auf einer Futterwiese und daher ist es wichtig,
			dass dort weder Kippenreste noch andere Gegenstände zurückbleiben. Achtet
			bittet auf die Sauberkeit eures Lagerplatzes.
		</p>
		<p>
			f. Im Übrigen gelten die Bestimmungen der Hausordnung auch für das
			Camping.
		</p>
		<p>
			g. Auf dem Campingplatz sind generell keine Musikanlagen erlaubt. Kleine
			Bluetooth Lautsprecher sind bis zur Nachtruhe gestattet. Bei
			Zuwiderhandlung werden die Musikanlagen durch das Sicherheitspersonal
			abgenommen.
		</p>
		<h3>14 Datenschutz</h3>
		<p>
			Siehe unter dem Reiter
			<NuxtLink to="/datenschutz">Datenschutz</NuxtLink>
		</p>
		<h3>15 Haftung des Veranstalters</h3>
		<p>
			a. Der Veranstalter haftet für beim Besucher verursachte Sach- und
			Vermögensschäden unbeschränkt, soweit sie von ihm oder seinen
			Erfüllungsgehilfen grob fahrlässig oder vorsätzlich verursacht wurden. Der
			Veranstalter haftet für beim Besucher verursachte Sach- und
			Vermögensschäden, soweit sie von ihm oder seinen Erfüllungsgehilfen leicht
			fahrlässig verursacht wurden, hingegen nur im Falle der Verletzung einer
			wesentlichen Vertragspflicht, deren Erfüllung die ordnungsgemäße
			Durchführung des Vertrags überhaupt erst ermöglicht und auf deren
			Einhaltung der Besucher regelmäßig vertrauen darf (sog. Kardinalpflicht).
			Seine Haftung für leichte Fahrlässigkeit ist in der Höhe beschränkt auf
			die bei Vertragsschluss vorhersehbaren Schäden, mit deren Entstehung
			typischerweise gerechnet werden muss.
		</p>
		<p>
			b. Für beim Besucher vom Veranstalter oder seinen Erfüllungsgehilfen
			verursachte Schäden an Leben, Körper und Gesundheit haftet der
			Veranstalter hingegen in vollem Umfang, also für jede Art von
			Fahrlässigkeit und für Vorsatz.
		</p>
		<p>
			c. Für Diebstähle auf dem Veranstaltungsgelände haftet der Veranstalter,
			soweit er nicht nach a. oder b. haftet, nicht, soweit er nicht erkennbar
			oder ausdrücklich eine Verwahrungspflicht übernommen hat.
		</p>
		<h3>16 Informationspflichten</h3>
		<p>
			Die Veranstalterin hat umgehend und frühestmöglich über die Durchführung
			und Änderungen ihrer Veranstaltungen zu informieren. Die Besucherin
			verpflichtet sich, sich regelmäßig über die Durchführung und Änderungen
			der Veranstaltung zu informieren.
		</p>
		<h3>17 Änderungen dieser AGB</h3>
		<p>
			Die Katholischen Jugendreferate Allgäu-Oberschwaben (haftungsbeschränkt)
			behalten sich das Recht vor, die AGB jederzeit mit sofortiger Wirkung zu
			ändern, zu ergänzen, zu ersetzen oder anderweitig zu modifizieren. Bei den
			Änderungen werden die Interessen der Besucherinnen angemessen
			berücksichtigen. Sofern die Kath. Jugendreferate Allgäu-Oberschwaben
			(haftungsbeschränkt) die AGB ändern, informieren diese hierüber auf deren
			Webseite. Für bereits erworbene Tickets werden die geänderten AGB sechs
			Wochen nach dieser Benachrichtigung wirksam, es sei denn Sie widersprechen
			der Änderung innerhalb von sechs Wochen nach der Benachrichtigung. Der
			Besuch einer Veranstaltung nach Ablauf des Zeitraums von sechs Wochen ohne
			Widerspruch gilt als Zustimmung zu den geänderten AGB.
		</p>
		<h3>18 Anwendbares Recht / Salvatorische Klausel</h3>
		<p>a. Es gilt ausschließlich deutsches Recht.</p>
		<p>
			b. Sollte eine Bestimmung dieser Bedingungen unwirksam oder undurchführbar
			sein oder werden, so wird dadurch die Wirksamkeit der übrigen
			Vereinbarungen nicht berührt. Eine solche Regelung, die dem beabsichtigten
			Zweck rechtswirksam am nächsten kommt, soll an die Stelle der unwirksamen
			oder undurchführbaren Vereinbarung treten. Gleiches gilt im Falle von
			Regelungslücken.
		</p>
	</div>
</template>
